export enum DISHWASHER_OPTIONS {
  BROWSE_DISHWASHERS = 'BROWSE_DISHWASHERS',
  SUPPLY_DISHWASHERS = 'SUPPLY_DISHWASHERS',
  NO_DISHWASHERS = 'NO_DISHWASHERS',
}
